/**
 * RESPONSIBILITY: the church's own story, on the About page.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Img, Link, RenderOf } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';
import { SectionName } from '../section-names';
import { LINK_HINT } from '../hints';

@Section({ name: SectionName.AboutStory, label: 'About · Our story' })
export class AboutStorySection {
  @Text({ label: 'Title', maxLength: 300, default: 'Our story' })
  heading!: string;

  @Paragraph({
    label: 'The story', maxLength: 20000, rows: 8, markdown: true, allow: ['verse'],
    description: 'God’s faithfulness since 2001.',
  })
  body!: string;

  @RenderOf('body')
  bodyHtml!: string;

  @Img({ label: 'Image', folder: 'about', maxSizeMb: 12, size: '1200 × 900' })
  image!: ImageValue;

  @Text({ label: 'Button text', maxLength: 120, default: 'Plan a visit', group: 'Button' })
  ctaLabel!: string;

  @Link({ label: 'Button link', group: 'Button', description: LINK_HINT })
  ctaHref!: string;

  @Text({
    label: 'Subtitle', maxLength: 120, default: 'Our story',
    description: 'The small line above the title.',
  })
  eyebrow!: string;

  @Text({
    label: 'Name on the photograph', maxLength: 200, group: 'Caption on the photograph',
    description: 'The larger line on the caption over the picture. Empty hides the caption.',
  })
  photoName!: string;

  @Text({
    label: 'Line under that', maxLength: 200, group: 'Caption on the photograph',
    description: 'e.g. Since 2001.',
  })
  photoSince!: string;

  @Text({
    label: 'Read-the-rest button', maxLength: 120, default: 'Read our full story',
    description:
      'The About page shows the opening of this story and this button; the whole of it '
      + 'is a page of its own. Empty hides the button.',
  })
  moreLabel!: string;
}
